import { useCallback, useEffect, useRef, useState } from 'react'
import { SrsRtcPlayer } from '@/core/classes/SrsRtcPlayer'

export function useSrsRtcPlayer() {
  const playerRef = useRef<SrsRtcPlayer>()

  const [stream, setStream] = useState<MediaStream | null>(null)

  useEffect(() => {
    const player = playerRef.current
    return () => {
      if (player) player.close()
    }
  }, [])

  const load = useCallback(async (url: string) => {
    playerRef.current = new SrsRtcPlayer()
    try {
      await playerRef.current.play(url)
      setStream(playerRef.current.getStream())
    } catch (err) {
      playerRef.current.close()
      console.error(`sdk play error : ${err}`)
    }
  }, [])

  const close = useCallback(() => {
    playerRef.current?.close()
    setStream(null)
  }, [])

  return {
    close,
    load,
    stream
  }
}
